import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useOnboardingStore } from '../../stores/useOnboardingStore';

const OnboardingGuard = ({ children }) => {
    const location = useLocation();
    const { isOnboardingComplete } = useOnboardingStore(state => state.onboarding);

    // Public routes that don't require onboarding
    const publicRoutes = ['/', '/about', '/pricing'];
    const isPublicRoute = publicRoutes.includes(location.pathname);

    // Onboarding route itself
    const isOnboardingRoute = location.pathname.startsWith('/onboarding');

    // If onboarding is not complete and user is trying to access protected route
    if (!isOnboardingComplete && !isPublicRoute && !isOnboardingRoute) {
        return <Navigate to="/onboarding" replace />;
    }

    return children;
};

export default OnboardingGuard;
